export default __webpack_public_path__ + "static/media/htb-mauricio.c144b2f5.jpg";